module.exports = __webpack_public_path__ + "static/img/2wv4.daf4a50e.png";